import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllContratoArquivoUseCase } from "../../../presentation/useCases/read/get_all_contrato_arquivo_use_case";
import { ContratoArquivoFilter } from "../../models/contrato_arquivo_filter";
import { ContratoArquivoLista } from "../../models/contrato_arquivo_lista";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


// GetAllContratoArquivoArquivoUseCase


export class GetAllContratoArquivoUseCase
  extends BasePaginatedUseCase<ContratoArquivoLista>
  implements IGetAllContratoArquivoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {
    super();
  }

  async getAllListagemContratoArquivo(
    filter: ContratoArquivoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemContratoArquivo(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
